import { render, staticRenderFns } from "./PendingApprover.vue?vue&type=template&id=a81b5ee4&scoped=true"
import script from "./PendingApprover.vue?vue&type=script&lang=js"
export * from "./PendingApprover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a81b5ee4",
  null
  
)

export default component.exports